// Formato de la huella de carbono, en kg CO₂e.
//
// UNA SOLA UNIDAD EN TODA LA APLICACIÓN: la misma que usan los reportes, donde la
// fórmula se declara como "Emisiones (kg CO₂e) = consumo × factor de emisión MINAM".
// Llegó a convivir un formato corto que imprimía solo "kg", y la misma cifra se leía
// distinta según la pantalla. "kg" a secas no dice qué se está midiendo —podría ser
// carga— así que la unidad completa va siempre, también en las tablas estrechas.
//
// El valor viene del cálculo real del backend. `null` significa que aún no hay
// insumos suficientes (un traslado que no cerró peso neto, o sin track GPS todavía),
// y se muestra como guion: no es cero, es "todavía no se sabe".

export function formatCarbonKg(kg: number | null | undefined): string {
  if (kg == null) return '— kg CO₂e'
  return `${kg.toLocaleString('es-PE', { maximumFractionDigits: kg < 10 ? 1 : 0 })} kg CO₂e`
}

/** Variante compacta para tablas: redondeada, pero con la unidad completa. */
export function formatCarbonKgShort(kg: number | null | undefined): string {
  if (kg == null) return '—'
  return `${Math.round(kg).toLocaleString('es-PE')} kg CO₂e`
}
